import { createCompanyProfileFetchers } from './company-profile/company-profile-fetchers';
import { createInternalTrackingFetchers } from './internal-tracking/internal-tracking-fetchers';
import { createJobArchitectureFetchers } from './job-architecture/job-architecture-fetchers';
import { createSkillFetchers, type SkillFetchers } from './skill/skill-fetchers';

import type { CompanyProfileFetchers } from './company-profile/company-profile-fetchers';
import type { InternalTrackingFetchers } from './internal-tracking/internal-tracking-fetchers';
import type { JobArchitectureFetchers } from './job-architecture/job-architecture-fetchers';
import type { HttpFetcherWithBaseUrl } from '../../../shared/source/http-fetcher';
import type { Translate } from '../../../shared/source/internationalization/translation';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';

export type ApplicationFetchers = CompanyProfileFetchers &
    InternalTrackingFetchers &
    JobArchitectureFetchers &
    SkillFetchers;

export type { AssignableReviewersItem, AssignReviewerItem } from './job-architecture/job-architecture-fetchers';

export type ApplicationFetchersDependencies = {
    readonly cobrainerApiFetcher: HttpFetcherWithBaseUrl;
    readonly translate: Translate;
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
};

export const createApplicationFetchers = (dependencies: ApplicationFetchersDependencies): ApplicationFetchers => {
    return {
        ...createCompanyProfileFetchers(dependencies),
        ...createJobArchitectureFetchers(dependencies),
        ...createSkillFetchers(dependencies),
        ...createInternalTrackingFetchers(dependencies),
    };
};
